// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3qe4n","productName":"Table_productName__2Jola"};